const currencyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

export function money(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return currencyFmt.format(value);
}

/** Signed, for charge lines where the direction carries the meaning. */
export function signedMoney(value: number): string {
  const formatted = currencyFmt.format(Math.abs(value));
  return value < 0 ? `−${formatted}` : formatted;
}

export function weight(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return `${value.toLocaleString('en-US', { maximumFractionDigits: 1 })} lb`;
}

/** "2026-09-01" -> "Tue Sep 1". Parsed as UTC so the day never slips a timezone. */
export function shortDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

export function dims(box: { length: number; width: number; height: number }): string {
  return `${box.length} × ${box.width} × ${box.height} in`;
}

export function percent(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return `${value.toFixed(1)}%`;
}

export function plural(count: number, one: string, many = `${one}s`): string {
  return `${count} ${count === 1 ? one : many}`;
}
